<script>
import { defineAsyncComponent } from 'vue';
import InlineCardLoader from '../../components/loaders/InlineCardsLoader.vue';

import '@rei/recommendations-slider/dist/style.css';
import '@rei/landing-product-recommendations/dist/style.css';

export default defineAsyncComponent({
  loader: () => import('@rei/landing-product-recommendations'),
  loadingComponent: InlineCardLoader,
});
</script>
